import { useContext, useEffect, useRef } from "react";
import { UserContext } from "../../../context";


const AlertMessage = () => {
    const { notificationAlert, activateAlert, setActivateAlert } = useContext(UserContext);
    const alertRef = useRef<NodeJS.Timeout>();

    useEffect(() => {
        if (alertRef.current)
            clearTimeout(alertRef.current);

        alertRef.current = setTimeout(() => {
            setActivateAlert(false);
        }, 6000);
    }, [activateAlert, setActivateAlert])

    const setNotificationAlertStyle = () => {
        if (notificationAlert?.type === "facilitatorNotification") {
            return "alert_message_facilitator";
        } else {
            return "alert_message";
        }
    }

    if (activateAlert && notificationAlert?.message !== "")
    return (
        <div className = {setNotificationAlertStyle()}>
            {notificationAlert?.message}
        </div>
    );

    return (<div></div>);

};

export default AlertMessage;
